import React from 'react';
import { Stack, IStackProps } from '@grubhubprod/gh-cookbook-react';
import {
  RouterButtonLink,
  RouterButtonLinkProps,
} from 'src/components/RouterLink/RouterButtonLink';

export type DataTableButtonLinkProps = RouterButtonLinkProps & IStackProps;

export const DataTableButtonLink: React.FC<DataTableButtonLinkProps> = ({
  children,
  x = 'none',
  y = 'none',
  ...rest
}) => (
  <Stack x={x} y={y}>
    <RouterButtonLink buttonSize="medium" {...rest}>
      {children}
    </RouterButtonLink>
  </Stack>
);
